(function() {
    'use strict';
    angular.module('app')
        .controller('ManifestsController', function ($location, $routeParams, $scope, ManifestService,
        ManifestsTableService, NonManifestsTableService, ScheduledPickUpsTableService, Carrier) {
            let vm = this;

            const tabs = ['manifest-search', 'non-manifested', 'scheduled-pickups'];
            vm.nonManifestTableData = new NonManifestsTableService().tableData;
            vm.manifestTableData = new ManifestsTableService().tableData;
            vm.schedPickupList = new ScheduledPickUpsTableService().tableData;
            vm.changeTab = changeTab;

            function changeTab(index) {
                vm.activeIndex = index;
                return $location.search({ tab: tabs[index] });
            }
            (function () {
                if ($routeParams != null) {
                    var params = $routeParams;
                    let index = vm.activeIndex = tabs.findIndex(tab => params.tab === tab);
                    vm.activeIndex = index > -1 ? index : 0;
                }
                if(!$routeParams.tab){
                    changeTab(0).replace();
                }
            })();
        })

})();


// WEBPACK FOOTER //
// ./js/controllers/ManifestsController.js